// app/javascript/dashboard/routes/dashboard/ia/ia.routes.js
import { frontendURL } from '../../../helper/URLHelper';

const IAIndex = () => import('./Index.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ia'),
    name: 'ia_dashboard',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: IAIndex,
  },
  {
    path: frontendURL('accounts/:accountId/ia/:section'),
    name: 'ia_section',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: IAIndex,
  },
];
